import React from 'react'

const WalnutTestContext = React.createContext()

export const WalnutTestProvider = WalnutTestContext.Provider
export const WalnutTestConsumer = WalnutTestContext.Consumer

export default WalnutTestContext